import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAPA } from '../../models/MAPA';

@Component({
  selector: 'app-step2common',
  templateUrl: './step2common.component.html'
})
export class Step2CommonComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() mapa: MAPA;
  @Input() linkForRouter: string;
  public current_uid = 'MAPA';

  constructor() { }

  ngOnInit(): void { }
}
